import RegisterPage from "../../components/registration/Registration";

const Register = () => {
  return (
    <>
      <RegisterPage />
    </>
  );
};

export default Register;
